module.exports = __webpack_public_path__ + "media/images/logo-mc-12268b335b80636a0fdd57d0e97c0482.png";